module.exports = __webpack_public_path__ + "img/yip-duck-fullbody.2c672a61.png";